import { render } from "./LoadingScreenSection.vue?vue&type=template&id=f39dbc24"
import script from "./LoadingScreenSection.vue?vue&type=script&lang=js"
export * from "./LoadingScreenSection.vue?vue&type=script&lang=js"

import "./LoadingScreenSection.vue?vue&type=style&index=0&id=f39dbc24&lang=css"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__